module.exports = __webpack_public_path__ + "app-static/img/p_01.74b96626.jpg";